const getters = {
  passoAtual: (state) => state.passoAtual,
  listaDocumentos: (state) => state.listaDocumentos,
  tipoJuntadaSelecionada: (state) => state.tipoJuntadaSelecionada,
  documentoSelecionado: (state) => state.documentoSelecionado
}

export default getters
